export const fmtInt = (n) => {
  if (n === null || n === undefined || Number.isNaN(n)) return "—";
  return new Intl.NumberFormat("en-US").format(n);
};

export const fmtSigned = (n) => {
  if (n === null || n === undefined || Number.isNaN(n)) return "—";
  const v = Number(n);
  const sign = v > 0 ? "+" : v < 0 ? "-" : "";
  return `${sign}${new Intl.NumberFormat("en-US").format(Math.abs(v))}`;
};

export const fmtCompact = (n) => {
  if (n === null || n === undefined || Number.isNaN(n)) return "—";
  const v = Number(n);
  const abs = Math.abs(v);
  if (abs >= 1_000_000) return `${(v / 1_000_000).toFixed(2)}M`;
  if (abs >= 1_000) return `${(v / 1_000).toFixed(1)}K`;
  return `${v}`;
};

export const fmtPct = (n) => {
  if (n === null || n === undefined || Number.isNaN(n)) return "—";
  return `${Number(n).toFixed(1)}%`;
};

export const signClass = (n) => {
  const v = Number(n);
  if (v > 0) return "text-pos";
  if (v < 0) return "text-neg";
  return "text-zinc-500";
};
